var LoggerImplQueued = /** @class */ (function () {
    function LoggerImplQueued() {
        this.queue = [];
    }
    LoggerImplQueued.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.queue.push({ type: 'log', args: args });
    };
    LoggerImplQueued.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.queue.push({ type: 'info', args: args });
    };
    LoggerImplQueued.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.queue.push({ type: 'warn', args: args });
    };
    LoggerImplQueued.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.queue.push({ type: 'error', args: args });
    };
    LoggerImplQueued.prototype.drain = function (dest) {
        this.queue.forEach(function (_a) {
            var type = _a.type, args = _a.args;
            dest[type].apply(dest, args);
        });
        this.queue = [];
    };
    LoggerImplQueued.prototype.clean = function () {
        this.queue = [];
    };
    return LoggerImplQueued;
}());
export { LoggerImplQueued };
//# sourceMappingURL=LoggerImplQueued.js.map